import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rtr-sign-in-button',
  templateUrl: './sign-in-button.component.html',
  styleUrls: ['./sign-in-button.component.less'],
  imports: [RouterLink, TranslatePipe],
})
export class SignInButtonComponent {}
